import { HelpersService, EstatusCreditos, TiposCreditos } from '../../services/tools/helpers.service';
import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
/*App imports*/
import { CreditosService } from "../../services/creditos.service";


@Component({
  selector: 'amortizacion-simple',
  templateUrl: './tabla-amortizacion.component.html',
  styleUrls: ['./tabla-amortizacion.component.scss'],
  providers: [NgbDropdownConfig]
})
export class TablaAmortizacionComponent implements OnInit {

  errors:any = {};
  private sub: any;
  id: number;
  public credito: any = {};
  tablaAmortizacion: any = [];
  public urlToSimulador: string = '/creditos/hipotecario/simulacion/';
  public showSaveButtons: boolean = false;
  public mostrarPrimeraPenalizacion: boolean = false;
  public mostrarSegundaPenalizacion: boolean = false;
  public reglasPenalizacion: string[] = [];

  constructor(
    private helperService: HelpersService, 
    private route: ActivatedRoute,
    private creditosService: CreditosService,
    private router: Router){
      
   }

  public ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
        const idCreditos = +params['id'];
        this.id = idCreditos; // (+) converts string 'id' to a number
        this.urlToSimulador = this.urlToSimulador + idCreditos;
  
        //Fill Credito data
        this.getCredito();
        this.getAmortizacion();
    });

    //Enlazamos la función que se va a ejecutar después de imprimirse el resumen del crédito
    window.onafterprint = () => {
        this.updateService();
    };
  }

  public ngOnDestroy() {
    //Remover el evento que se ejecuta después de imprimir una pantalla
    window.onafterprint = undefined;
    this.sub.unsubscribe();
  }

  private getCredito(){
    //TODO: Manejar cuando el id no retorna un crédito valido
    this.creditosService.get(this.id).subscribe(
      (response)=>
      {
        //Este modelo lo utilizamos al actualizar el estatus del crédito
        this.credito = response.json().content;

        if(this.credito.statusCredito === EstatusCreditos.Borrador || this.credito.statusCredito === EstatusCreditos.Pendiente){
          this.showSaveButtons = true;
        }
        if(this.credito.idTipos_Creditos === TiposCreditos.Estacionario || this.credito.idTipos_Creditos === TiposCreditos.Carburacion || this.credito.idTipos_Creditos === TiposCreditos.PlusPension){
          this.mostrarPrimeraPenalizacion = true;
          this.reglasPenalizacion.push('Se aplica una penalización del 10%, en caso de no cubrir el 85% del pago sugerido, antes del cierre de mes.');
        }
        else if(this.credito.idTipos_Creditos !== TiposCreditos.Nomina){
          this.mostrarPrimeraPenalizacion = true;
          this.mostrarSegundaPenalizacion = true;
          this.reglasPenalizacion.push('Se aplica una penalización del 5%, en caso de pagar dentro de la semana después de la fecha límite de pago.');
          this.reglasPenalizacion.push('Se aplica una penalización del 12%, en caso de pagar después del límite de la primera penalización.');
        }
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.setBackendErrors(error.json().content);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  private getAmortizacion(){
    //TODO: Manejar cuando el id no retorna un crédito valido
    this.creditosService.getTablaAmortizacion(this.id).subscribe(
      (response)=>
      {
        this.tablaAmortizacion = response.json().content;
        console.log('#tabla', this.tablaAmortizacion);
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.setBackendErrors(error.json().content);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public printSummaryCredito(){
    //Imprimir pantalla
    window.print();
  }

  public closeSummaryCredito(){
    this.updateService();
  }

  /**
   * Actualizar el estatus para marcar este crédito como pendiente (status = 1)
   */
  private updateService(){

    const credito = { 
      id : this.credito.id,
      statusCredito : this.credito.statusCredito
    };

    //Para los créditos que están en borrador (0) hay que actualizarlos a estatus pendiente (1)
    if(credito.statusCredito !== 0){
      //Aquí habría que definir que se va a realizar cuando un crédito esta en un estatus diferente al borrador
      this.router.navigate(['/creditos']);
      return;
    }

    credito.statusCredito = 1;

    this.creditosService.update(credito).subscribe(
        (response)=>
        {
            let creditData = response.json().content;
            
            //TODO: Navigate to the crédits list 
            this.helperService.notification('Crédito creado', 'Se ha creado exitosamente el crédito ', 'success');
            this.router.navigate(['/creditos']);
        }, error =>
        {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
            this.setBackendErrors(error.json().content);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
        }
    );
  }

  

  /**
   * Helpers
   */

  private setBackendErrors(errors:any[]){
    let temp_errors = [];
    
    Object.keys(errors).forEach(function(key){
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }

  private verificarSiNoEsCreditoCarburacion(){
    return this.credito.idTipos_Creditos !== TiposCreditos.Carburacion;
  }

}



// WEBPACK FOOTER //
// ./src/app/creditos/tabla-amortizacion/tabla-amortizacion.component.ts